import React, { Component } from 'react';
import { Link } from 'react-router-dom';
// import ReactMapboxGl, { Layer, Feature } from 'react-mapbox-gl';

// import logo from '../../assets/img/logo.png';

class Footer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    // Back to top
    componentDidMount() {
        window.addEventListener('scroll', () => {
            this.setState({
                isTop: window.scrollY > 300
            });
        }, false);
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    render() {
        // const Map = ReactMapboxGl({
        //     accessToken:
        //         'pk.eyJ1IjoiYWJlZHNoIiwiYSI6ImNrNnRyZ3d4aDAyMzkzZXBoc3RsYnM0aGwifQ.yhr3W_OOI6xXElmSY8cyPg'
        // });
        return (
            <footer className="sigma-footer">
                <div className="sigma-footer-top">
                    <div className="container-fluid">
                        <div className="row no-gutters">
                            <div className="col-lg-8">
                                <div className="row">
                                    <div className="col-lg-6">
                                        {/*====== Back to top ======*/}
                                        <div className="sigma-backto-top">
                                            <Link to="#" className="back-to-top" id="backToTop" onClick={() => this.scrollToTop()}>
                                                <i className="fal fa-chevron-up" /> Back to Top
                </Link>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="h-100 d-flex align-items-center justify-content-end">
                                            {/* <select className="nice-select">
                                                <option>English</option>
                                                <option>Español</option>
                                            </select> */}
                                            {/* <select className="nice-select">
                                                <option>USD</option>
                                                <option>GBP</option>
                                                <option>INR</option>
                                            </select> */}
                                        </div>
                                    </div>
                                </div>
                                {/*====== Footer content ======*/}
                                <div className="sigma-footer-box">
                                    <div className="sigma-footer-box-top">
                                        {/* <div className="ft-logo"> */}
                                            {/* <Link to="/">
                                                <img src={logo} alt="Logo" />
                                            </Link> */}
                                            
                                        {/* </div> */}
                                        <div className="site-logo site-logo-text">
                                            <Link to="/">
                                                <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xmlSpace="preserve">
                                                    <path d="M369.853,250.251l-100-241C267.53,3.65,262.062,0,255.999,0s-11.531,3.65-13.854,9.251l-100,241    c-1.527,3.681-1.527,7.817,0,11.498l100,241c2.323,5.601,7.791,9.251,13.854,9.251s11.531-3.65,13.854-9.251l100-241    C371.381,258.068,371.381,253.932,369.853,250.251z M255.999,457.861L172.239,256l83.76-201.861L339.759,256L255.999,457.861z" fill="#ffffff" />
                                                    <path className="diamond-spark spark-1" d="M139.606,118.393l-63-63c-5.858-5.857-15.356-5.857-21.213,0c-5.858,5.858-5.858,15.356,0,21.213l63,63    c2.928,2.929,6.767,4.394,10.606,4.394s7.678-1.465,10.607-4.394C145.465,133.748,145.465,124.25,139.606,118.393z" fill="#ffffff" />
                                                    <path className="diamond-spark spark-2" d="M456.607,55.393c-5.858-5.857-15.356-5.857-21.213,0l-63,63c-5.858,5.858-5.858,15.356,0,21.213    c2.928,2.929,6.767,4.394,10.606,4.394s7.678-1.465,10.607-4.394l63-63C462.465,70.748,462.465,61.25,456.607,55.393z" fill="#ffffff" />
                                                    <path className="diamond-spark spark-3" d="M139.606,372.393c-5.858-5.857-15.356-5.857-21.213,0l-63,63c-5.858,5.858-5.858,15.356,0,21.213    C58.322,459.535,62.16,461,65.999,461s7.678-1.465,10.607-4.394l63-63C145.465,387.748,145.465,378.25,139.606,372.393z" fill="#ffffff" />
                                                    <path className="diamond-spark spark-4" d="M456.607,435.393l-63-63c-5.858-5.857-15.356-5.857-21.213,0c-5.858,5.858-5.858,15.356,0,21.213l63,63    c2.928,2.929,6.767,4.394,10.606,4.394s7.678-1.465,10.607-4.394C462.465,450.748,462.465,441.25,456.607,435.393z" fill="#ffffff" />
                                                </svg>
                                                <div className="site-logo-text">
                                                    <h3>Raj</h3>
                                                    <h6>jewellers</h6>
                                                </div>
                                            </Link>
                                        </div>
                                        <ul className="ft-social-media">
                                            <li>
                                                <Link to="#">
                                                    <i className="fab fa-facebook-f" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <i className="fab fa-instagram" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="#">
                                                    <i className="fab fa-twitter" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="sigma-footer-nav">
                                        <ul className="ft-nav">
                                            <li className="menu-item">
                                                <Link to="/">
                                                    Home
                                                </Link>
                                            </li>
                                            <li className="menu-item">
                                                <Link to="/about">
                                                    About Us
                                                </Link>
                                            </li>
                                            {/* <li className="menu-item">
                                                <Link to="/blog-grid">
                                                    News
                                                </Link>
                                            </li> */}
                                            {/* <li className="menu-item">
                                                <Link to="/gallery">
                                                    Gallery
                                                </Link>
                                            </li> */}
                                            <li className="menu-item">
                                                <Link to="/contact">
                                                    Contact
                                            </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                {/* <Map
                                    // eslint-disable-next-line react/style-prop-object
                                    style="mapbox://styles/mapbox/light-v10"
                                    className="contact-maps"
                                >
                                    <Layer type="symbol" id="marker" layout={{ 'icon-image': 'marker-15' }}>
                                        <Feature coordinates={[-77.04, 38.907]} zoom={11.5} />
                                    </Layer>
                                </Map> */}
                                <div className="footer-map">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2481.6300743286733!2d0.0310367756595241!3d51.538344508443494!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a7b8055b54cb%3A0x8677ac47099dd01f!2sRaj%20Jewellers!5e0!3m2!1sen!2sin!4v1773483952114!5m2!1sen!2sin"
                                        width="100%"
                                        height="294"
                                        style={{ border: 0 }}
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="Raj Jewellers Location"
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sigma-footer-bottom">
                    <div className="container-fluid">
                        <div className="sigma-footer-bottom-inner">
                            <div className="row no-gutters align-items-end">
                                <div className="col-lg-4">
                                    <div className="sigma-footer-contact">
                                        <ul>
                                            <li>
                                                <i className="flaticon-phone" />
                                                <Link to="tel:"><span>Phone Number</span> <p>+0208 4710333</p><p> +0208 4727755</p></Link>
                                            </li>
                                            {/* <li>
                                                <i className="flaticon-message" />
                                                <Link to="mailto:"><span>Email Address</span>  raj-jewellers07@hotmail.co.uk</Link>
                                            </li> */}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4" >
                                    <div className="sigma-footer-contact">
                                        <ul>
                                            <li>
                                                <i className="flaticon-message" />
                                                <Link to="mailto:"><span>Email Address</span>  raj-jewellers07@hotmail.co.uk</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <div className="col-lg-3" >
                                    <div className="sigma-footer-search">
                                        <form>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <button><i className="fal fa-search" /></button>
                                                </div>
                                                <input type="text" name="#" className="form-control" placeholder="Search..." />
                                            </div>
                                        </form>
                                    </div>
                                </div> */}
                                <div className="col-lg-4">
                                    <div className="sigma-footer-contact style-2">
                                        <ul>
                                            <li>
                                                <i className="flaticon-location-pin" />
                                                <Link to="#"><span>Shop address </span> 258 Green street,<p>London, E7 8lF</p></Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Copyright */}
                <div className="sigma-copyright">
                    <div className="container-fluid">
                        <div className="sigma-copyright-inner">
                            <div className="row">
                                <div className="col-lg-12 col-md-5 order-2 order-md-1">
                                    <p className="sigma-copyright-text">Copyright By@<Link to="#">Raj Jeweller</Link> - 2026</p>
                                </div>
                                {/* <div className="col-lg-6 col-md-7 order-1 order-md-2">
                                    <div className="sigma-copyright-menu">
                                        <ul>
                                            <li>
                                                <Link to="#">Terms of use</Link>
                                            </li>
                                            <li>
                                                <Link to="#">Privacy Environmental Policy</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </footer >

        );
    }
}

export default Footer;